import { Grid, Typography } from '@material-ui/core';
import { useFormikContext } from 'formik';
import ContentSubject from 'models/ContentSubject';
import React from 'react';
import { EMPTY_SUBJECT_FORM } from '../../constants';
import { SubjectArea } from '../../types';
import StepContainer from '../StepContainer';
import SubjectSection from './SubjectSection';

const SubjectAreaForm: React.FC = () => {
  const { setFieldValue, getFieldMeta } = useFormikContext();

  const formValue = getFieldMeta<SubjectArea[]>('subjectAreas').value;

  function handleAddClick() {
    setFieldValue('subjectAreas', [...formValue, { ...EMPTY_SUBJECT_FORM }]);
  }

  function handleRemoveClick(index: number) {
    setFieldValue(
      'subjectAreas',
      formValue.filter((_, i) => i !== index),
    );
  }

  const selectedSubjects = formValue
    .map(({ subject }) => subject)
    .filter((subject) => subject !== null);
  const availableSubjects = Object.values(ContentSubject).filter(
    (subject) => !selectedSubjects.includes(subject),
  );

  return (
    <StepContainer>
      <Grid item>
        <Typography gutterBottom>What subject areas does this lesson cover?</Typography>
      </Grid>
      <Grid item>
        {formValue.map((_, index) => (
          <SubjectSection
            key={index}
            index={index}
            disableAddButton={
              index < formValue.length - 1 ||
              formValue.length > Object.values(ContentSubject).length - 1
            }
            disableRemoveButton={formValue.length < 2}
            onAddClick={handleAddClick}
            onRemoveClick={() => handleRemoveClick(index)}
            availableSubjects={availableSubjects}
          />
        ))}
      </Grid>
    </StepContainer>
  );
};

export default SubjectAreaForm;
